import { createAction, props } from '@ngrx/store';
import { PatientAllergy } from '../../models/patient-allergy';

export const getPatientAllergies = createAction('[Patient Allergy] Get Patient Allergies');

export const getPatientAllergiesSuccess = createAction(
  '[Patient Allergy] Get Patient Allergies Success',
  props<{
    patientAllergies: PatientAllergy[];
    pageNumber: number;
    isAtEndOfData: boolean;
    totalRecordCount: number;
  }>()
);

export const getPatientAllergiesFailure = createAction(
  '[Patient Allergy] Get Patient Allergies Failure',
  props<{ error: unknown }>()
);

export const setPageNumber = createAction('[Patient Allergy] Set Page Number', props<{ pageNumber: number }>());

export const resetFilters = createAction('[Patient Allergy] Reset Filters');

export const getAllPatientAllergies = createAction(
  '[Patient Allergy] Get All Patient Allergies',
  props<{ patientId: number }>()
);

export const getAllPatientAllergiesSuccess = createAction(
  '[Patient Allergy] Get All Patient Allergies Success',
  props<{ patientAllergies: PatientAllergy[]; patientId: number; loadedAt: number }>()
);

export const getAllPatientAllergiesFailure = createAction(
  '[Patient Allergy] Get All Patient Allergies Failure',
  props<{ error: unknown }>()
);

export const invalidateAllergyCache = createAction('[Patient Allergy] Invalidate Allergy Cache');

export const recordPatientAllergyPrintEvent = createAction(
  '[Patient Allergy] Record Print Event',
  props<{ patientId: number; patientAllergyIds: number[] }>()
);

export const recordPatientAllergyPrintEventSuccess = createAction('[Patient Allergy] Record Print Event Success');

export const recordPatientAllergyPrintEventFailure = createAction(
  '[Patient Allergy] Record Print Event Failure',
  props<{ error: unknown }>()
);
